import { restResourceRequester } from "../rest-resource-requester";
import { CreateComponentProjectRequest } from "../component-project/create-component-project/CreateComponentProjectRequest";
import { CreateComponentProjectResponse } from "../component-project/create-component-project/CreateComponentProjectResponse";
import { GetComponentProjectRequest } from "../component-project/get-component-project/GetComponentProjectRequest";
import { GetComponentProjectResponse } from "../component-project/get-component-project/GetComponentProjectResponse";
import { UpdateComponentProjectRequest } from "../component-project/update-component-project/UpdateComponentProjectRequest";
import { UpdateComponentProjectResponse } from "../component-project/update-component-project/UpdateComponentProjectResponse";

interface ComponentProjectRestResource {
  createComponentProject(
    request: CreateComponentProjectRequest,
  ): Promise<CreateComponentProjectResponse>;
  getComponentProject(
    request: GetComponentProjectRequest,
  ): Promise<GetComponentProjectResponse>;
  updateComponentProject(
    request: UpdateComponentProjectRequest,
  ): Promise<UpdateComponentProjectResponse>;
}

const REST_RESOURCE_NAME = {
  COMPONENT_PROJECT: "/component-project",
};

/**
 * GET /get-component-project
 */
const getComponentProject = restResourceRequester<
  GetComponentProjectRequest,
  GetComponentProjectResponse
>("GET", (request) => {
  return `${REST_RESOURCE_NAME.COMPONENT_PROJECT}/${request.pjtId}`;
});

/**
 * PUT /update-component-project
 */
const updateComponentProject = restResourceRequester<
  UpdateComponentProjectRequest,
  UpdateComponentProjectResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME.COMPONENT_PROJECT}/${request.pjtId}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /create-component-project
 */
const createComponentProject = restResourceRequester<
  CreateComponentProjectRequest,
  CreateComponentProjectResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.COMPONENT_PROJECT}`,
  (request) => JSON.stringify(request),
);

export const ComponentProjectRestResource: ComponentProjectRestResource = {
  createComponentProject: createComponentProject,
  getComponentProject: getComponentProject,
  updateComponentProject: updateComponentProject,
};
